// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/services/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const fragment = window.location.hash || "";
    const sessionMatch = fragment.match(/session_id=([^&]+)/);
    if (!sessionMatch) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = sessionMatch[1];

    api.googleSession(sessionId)
      .then((res) => {
        setSession(res.token, res.user);
        toast.success("Connexion Google reussie");
        navigate("/", { replace: true });
      })
      .catch((err) => {
        toast.error(err.message || "Echec de la connexion Google");
        navigate("/login", { replace: true });
      });
  }, [navigate, setSession]);

  return (
    <div data-testid="auth-callback-page" style={{ minHeight: "100dvh", backgroundColor: "#000", color: "#fff", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "16px" }}>
      <Loader2 size={28} className="animate-spin" color="#22c55e" />
      <p style={{ fontSize: "14px", color: "#9ca3af" }}>Connexion en cours...</p>
    </div>
  );
}
